import { ZoneService } from "./../_services/zone.service";
import { Zone } from "./../_models/zone";
import { City } from "./../_models/city";
import { CityService } from "./../_services/city.service";
import { StateService } from "./../_services/state.service";
import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { forkJoin } from "rxjs";
import { switchMap } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { Globals } from "../globals";
import { ProductPrice } from "../_models/product-price";
import _ from "lodash";
import { State } from "../_models/state";

@Component({
  selector: "app-view-city-page",
  templateUrl: "./view-city-page.component.html",
  styleUrls: ["./view-city-page.component.scss"],
})
export class ViewCityPageComponent implements OnInit {
  public categories = new FormControl();
  public isDataLoaded = false;
  public isModified = false;
  public city: City;
  public states: State[];
  public zones: Zone[];
  public showAddContents = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    public stateService: StateService,
    public zoneService: ZoneService,
    public cityService: CityService,
    public globals: Globals,
    private location: Location,
    public snackBar: MatSnackBar,
    public uploadDialog: MatDialog,
    private router: Router
  ) {}

  public activate(): void {
    this.city.active = true;
    this.save();
  }

  public back(): void {
    this.location.back();
  }

  public cancel(): void {
    this.refresh();
  }

  public dataChanged(): void {
    this.isModified = true;
  }

  public deactivate(): void {
    this.city.active = false;
    this.save();
  }

  public delete() {
    this.cityService.deleteCity(this.city.id).subscribe(
      (res) => {
        this.router.navigate(["regional", "cities"]);
      },
      (err) => {
        console.error(err);
        this.showErrorMessage(
          "Sorry, your request cannot be process at the moment!"
        );
      }
    );
  }

  public getImageUrl(): string {
    return environment.imageUrl;
  }

  public loadData(cityId: number) {
    this.cityService.getCity(cityId).subscribe(
      (city) => {
        this.city = city;
        this.isDataLoaded = true;
        this.isModified = false;
      },
      (err) => {
        if (err.status == 404) {
          this.isDataLoaded = true;
          this.showErrorMessage("City not found");
        }
      }
    );
  }

  public ngOnInit(): void {
    forkJoin({
      states: this.stateService.getStates(),
      zones: this.zoneService.getZones(),
    }).subscribe(({ states, zones }) => {
      this.states = states;
      this.zones = zones;
    });
    this.activatedRoute.paramMap
      .pipe(
        switchMap((params: ParamMap) => {
          const stateId = params.get("id");
          if (!this.globals.isNullOrEmpty(stateId)) {
            this.loadData(parseInt(stateId, 10));
          } else {
            this.showErrorMessage("Please specify the state Id!");
          }

          return Promise.resolve();
        })
      )
      .subscribe();
  }

  public refresh(): void {
    this.isDataLoaded = false;
    this.loadData(this.city.id);
  }

  isCityValid() {
    return this.city.name && this.city.code;
  }

  public save(): void {
    if (!this.isCityValid()) {
      this.showErrorMessage("Name or code is required");
      return;
    }

    this.cityService.updateCity(this.city).subscribe(
      (res) => {
        this.refresh();
      },
      (err) => {
        console.error(err);
        this.showErrorMessage(
          "Sorry, your request cannot be process at the moment!"
        );
      }
    );
  }

  public showErrorMessage(message): void {
    this.snackBar.open(message, "Error", {
      duration: 2000,
    });
  }

  public updateList(price: ProductPrice, propertys: string, value: any) {
    console.log(value);
  }
}
